import { AutoMap } from "@automapper/classes";
import { ESamplingMode } from "./enums/sampling-mode";

export class ProcessCalculation {
    @AutoMap()
    Duration!: number;
    @AutoMap()
    SamplingMode!: ESamplingMode;

    public constructor(init?: Partial<ProcessCalculation>) {
        Object.assign(this, init);
    }
}